export default function getOriginalLocation(order, locations) {
  if (order?.lodge_id) {
    const loc = (locations ?? []).find((x) => x.id === order.lodge_id) ?? null
    return loc ? { ...loc, weigh_in_code: loc.lodge_code ?? loc.weigh_in_code ?? "" } : null
  }
  if (order?.location_id) {
    const loc = (locations ?? []).find((x) => x.id === order.location_id) ?? null
    return loc ? { ...loc, weigh_in_code: loc.lodge_code ?? loc.weigh_in_code ?? "" } : null
  }
  return null
}

